import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "mock-menu-box"
};
const _hoisted_2 = {
  class: "page-list-box"
};
const _hoisted_3 = {
  class: "page-no"
};
const _hoisted_4 = {
  class: "item-no"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_tag = _resolveComponent("el-tag");
  const _component_el_button_group = _resolveComponent("el-button-group");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.menuList, (pageItem, pageIndex) => {
    return _openBlock(), _createBlock(_component_el_button, {
      key: 'pageItem' + pageIndex,
      type: $props.paperNo == pageIndex ? 'primary' : '',
      size: "small",
      plain: "",
      onClick: $event => $setup.changePaper(pageIndex)
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.numChat[pageIndex]), 1)]),
      _: 2
    }, 1032, ["type", "onClick"]);
  }), 128))]), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.menuList[$props.paperNo], (menuItem, i) => {
    return _openBlock(), _createBlock(_component_el_tag, {
      key: i,
      class: "mx-1",
      effect: menuItem.menuTaskNo == $setup.menuTaskNo ? 'dark' : 'light',
      type: menuItem.isfinish ? '' : 'info',
      onClick: $event => $setup.change(menuItem),
      round: ""
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(menuItem.totalTask + 1), 1)]),
      _: 2
    }, 1032, ["effect", "type", "onClick"]);
  }), 128))])]), _createVNode(_component_el_button_group, null, {
    default: _withCtx(() => [_createVNode(_component_el_button, {
      type: "primary",
      disabled: $props.paperNo == 0 && $setup.menuList[$props.paperNo][0].itemNo == $props.itemNo,
      onClick: $setup.back
    }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode("Back", -1)]))]),
      _: 1
    }, 8, ["disabled", "onClick"]), _createVNode(_component_el_button, {
      type: "primary",
      disabled: $props.paperNo + 1 == $setup.menuList.length && $setup.menuList[$props.paperNo][$setup.menuList[$props.paperNo].length - 1].itemNo == $props.itemNo,
      onClick: $setup.next
    }, {
      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("Next", -1)]))]),
      _: 1
    }, 8, ["disabled", "onClick"])]),
    _: 1
  })]);
}